export const selectOrganizations = ({ organizations }) => organizations;

export const selectOrganizationsList = (state) => selectOrganizations(state).list.data;
export const selectOrganizationsListIsFetching = (state) =>
  selectOrganizations(state).list.isFetching;
export const selectOrganizationsFilter = (state) =>
  selectOrganizations(state).list.filter;

export const selectOrganizationsEditForm = (state) => selectOrganizations(state).editForm;
export const selectOrganizationsEditId = (state) =>
  selectOrganizations(state).editForm.id;
export const selectOrganizationsEditRules = (state) =>
  selectOrganizations(state).editForm.rules;
export const selectOrganizationsEditUsers = (state) =>
  selectOrganizations(state).editForm.users;
export const selectOrganizationsIsSubmitting = (state) =>
  selectOrganizations(state).editForm.isSubmitting;

export const selectOrganizationsRules = (state) => selectOrganizations(state).allRules;

export const selectAnalysts = (state) => selectOrganizations(state).analystsFullList;
export const selectAnalystsList = (state) => selectAnalysts(state).data;
export const selectAnalystsIsFetching = (state) => selectAnalysts(state).isFetching;
export const selectAnalystsIsSubmitting = (state) => selectAnalysts(state).isSubmitting;

export const organizationEditAttendees = (state) =>
  selectOrganizationsEditForm(state).attendees;



// WEBPACK FOOTER //
// ./redux/selectors/organizations.js